import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOptgroup, MatOption } from '@angular/material/autocomplete';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { ReasonType } from 'enums/ReasonType';
import { ReasonModel } from 'models/generated/Entities.GormCrm.Reason';
import { ReasonCategoryModel } from 'models/generated/Entities.GormCrm.ReasonCategory';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { ReasonService } from 'services/reason.service';

@Component({
	selector: 'reason-select',
	templateUrl: './reason-select.component.html',
	imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatOptgroup]
})
export class ReasonSelectComponent {

	@Input() label: string;
	@Input() type: ReasonType = 0;
	@Input('reasonId') set reasonIdInput(value: string | undefined) {
		this.reasonId = value;
	}
	@Output() reasonIdChange = new EventEmitter<string | undefined>();
	@Output() valueChange = new EventEmitter<ReasonModel>();
	@Output() reasonsLoaded = new EventEmitter<void>();
	@Input() required = false;

	public reasonId?: string;
	public categories: ReasonCategoryModel[] = [];
	public reasons: ReasonModel[] = [];

	public reasonsInCategory(category?: ReasonCategoryModel): ReasonModel[] {
		return this.reasons.filter(reason => reason.categoryId === category?.id);
	}

	constructor(reasonService: ReasonService, private readonly validation: FormValidationService, private readonly translate: TranslatePipe) {
		this.label = this.translate.transform('termination.reason.label');
		Promise.all([
			reasonService.getAllReasons(),
			reasonService.getAllReasonCategories()
		]).then(([reasons, categories]) => {
			this.reasons = reasons.filter(r => (r.types & this.type) === this.type);
			this.categories = categories.filter(c => this.reasons.some(r => r.categoryId == c.id));
			this.reasonsLoaded.emit();
		});

		this.validation.fieldStateChanged(this, !this.required, true);
	}

	public setValue(reasonId: string | undefined) {
		this.validation.fieldStateChanged(this, !this.required || reasonId !== undefined, false);
		this.valueChange.emit(this.reasons.find(r => r.id == reasonId));
		this.reasonIdChange.emit(reasonId);
	}

	markAsPristine() { }
}
